module.exports = __webpack_public_path__ + "img/10.0d0449a5.svg";